<template>
    <div style="background-color: #f5f5f5;padding-top:100px;">

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">最新职位</div>
                    <ul>
                        <li v-for="(n_job, index) in n_job_list" :key="index"><a href="javascript:void(0);" @click.stop="article_view(n_job.id,zplb)" :title="'发布时间：'+n_job.createDate">{{ index+1 }}.{{ n_job.zhiwei}}</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <form @submit.prevent="SearchForm" class="searchform">
                        <input type="text" class="input" v-model="form.zhiwei" placeholder="输入职位关键词" /><button class="button">搜索职位</button><a href="javascript:void(0);" @click.stop="ResetSearch()">重置</a>
                    </form>
                    <div id="job_list">
                        <!-- <ul>
                            <li v-for="(article, index) in article_list" :key="index" :id="article.id" @click.stop="article_view(article.id,zplb)">
                                <span class="t" v-if="article.node04 == 'Y'" :title="article.zhiwei"><i>新</i>{{ article.zhiwei }}</span>
                                <span class="t t_disable" v-else title="该职位已过期">{{ article.zhiwei }}</span>
                                <div class="yuexin" v-if="article.node04 == 'Y'">{{ article.yuexin }}</div>
                                <div class="yuexin yuexin_disable" v-else>{{ article.yuexin }}</div>
                                <span style="float:left;width:50%;height:40px;line-height:40px;color:#666;font-size:14px;">{{ article.zwlb }}   |   {{ article.diqu }}</span>
                                <span style="float:right;width:50%;height:40px;line-height:40px;color:#999;font-size:14px;text-align:right;">发布时间：{{ article.createDate }}</span>
                            </li>
                        </ul> -->
                        <ul>
                            <li v-for="(article, index) in article_list" :key="index" :id="article.id" v-if="article.node04 == 'Y'">
                                <div @click.stop="article_view(article.id,zplb)">
                                    <span class="t" :title="article.zhiwei"><i>新</i>{{ article.zhiwei }}</span>
                                    <div class="yuexin">{{ article.yuexin }}</div>
                                    <span style="float:left;width:50%;height:40px;line-height:40px;color:#666;font-size:14px;">{{ article.zwlb }}   |   {{ article.diqu }}</span>
                                    <span style="float:right;width:50%;height:40px;line-height:40px;color:#999;font-size:14px;text-align:right;">发布时间：{{ article.createDate }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="page">
                        <span>总共 {{ total_page }} 页，当前第 {{ pageNum }} 页</span>
                        <a href="javascript:void(0);" @click.stop="page('first')">首页</a>
                        <a href="javascript:void(0);" @click.stop="page('pre')" v-if="page_pre == 1">上一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">上一页</a>
                        <a href="javascript:void(0);" @click.stop="page('next')" v-if="page_next == 1">下一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">下一页</a>
                        <a href="javascript:void(0);" @click.stop="page('last')">尾页</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { RenCaiZhaoPin } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '招聘信息',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            article_list: '',
            n_job_list:'',

            zplb: this.$route.query.zplb, //传入的id

            form:{
                zhiwei:'',
            },

            //翻页
            pageNum: 1, //当前页
            pageSize: 20, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页
            
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        
        this.RenCaiZhaoPin_data( this.form.zhiwei, this.zplb, this.pageNum, this.pageSize );
        this.New_job_data( this.zplb, this.pageNum, this.pageSize );

        if( this.zplb == '701' ){
            this.title = '校园招聘';
        }else if( this.zplb == '702' ){
            this.title = '社会招聘';
        };
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        ResetSearch(){
            this.form.zhiwei = '';
            this.RenCaiZhaoPin_data( this.form.zhiwei, this.zplb, this.pageNum, this.pageSize );
        },
        SearchForm(){
            //console.log(JSON.stringify(this.form));
            this.RenCaiZhaoPin_data( this.form.zhiwei, this.zplb, this.pageNum, this.pageSize );
        },
        article_view( id,zplb ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "JobView",
                query: { id: id, zplb:zplb },
            });
        },
        page(e) {
            //分页参数
            if( e == "first" ){
                //首页
                this.RenCaiZhaoPin_data(
                    this.form.zhiwei,
                    this.zplb,
                    1,
                    this.pageSize,
                );
            } else if ( e == "pre" ) {
                //上一页
                this.RenCaiZhaoPin_data(
                    this.form.zhiwei,
                    this.zplb,
                    this.pageNum - 1,
                    this.pageSize,
                );
            } else if ( e == "next" ) {
                //下一页
                this.RenCaiZhaoPin_data(
                    this.form.zhiwei,
                    this.zplb,
                    this.pageNum + 1,
                    this.pageSize,
                );
            } else if( e == "last" ){
                //尾页
                this.RenCaiZhaoPin_data(
                    this.form.zhiwei,
                    this.zplb,
                    this.total_page,
                    this.pageSize,
                );
            };
        },
        New_job_data( zplb ){ //文章分类显示
            RenCaiZhaoPin({
                zplb: zplb, //分类
                pageNum : 1, //当前是第几页
                pageSize : 5, //每页显示多少条
            }).then((res) => {
                //console.log( res );
                this.n_job_list = res.rows;
            });
        },
        RenCaiZhaoPin_data( zhiwei, zplb,pageNum, pageSize ){ //文章分类显示
            RenCaiZhaoPin({
                zhiwei: zhiwei, //职位
                zplb: zplb, //分类
                pageNum : pageNum, //当前是第几页
                pageSize : pageSize, //每页显示多少条
            }).then((res) => {
                //console.log( res );
                this.article_list = res.rows;
                //翻页
                this.pageNum = pageNum; //当前页
                this.total = res.total; //总数据

                this.total_page = Math.ceil( res.total / this.pageSize );

                if( this.pageNum < this.total_page && this.pageNum == 1){
                    this.page_pre = 0;
                    this.page_next = 1;
                } else if ( this.pageNum == this.total_page && this.pageNum !== 1 ) {
                    this.page_pre = 1;
                    this.page_next = 0;
                } else if ( this.pageNum == this.total_page && this.total_page == 1 ) {
                    this.page_pre = 0;
                    this.page_next = 0;
                }else{
                    this.page_pre = 1;
                    this.page_next = 1;
                };

            });
        },
    },
};
</script>
<style lang="less" scoped>
#job_list ul{
    margin:0px 30px;
}
#job_list li{
    position: relative;
    zoom:1;
    overflow: auto;
    margin: 10px auto;
    padding: 20px 30px;
    //height: 110px;
    border: 1px solid #ddd;
    background-color: #fff;
}
#job_list li:hover{
    cursor: pointer;
    background-color: #f5f5f5;
}

#job_list li .t{
    display:block;
    height:40px;
    line-height:40px;
    font-size:20px;
    color: #171615;
    background-repeat: no-repeat;
    background-size: 60px auto;
    background-position: center right;
	background-image: url('data:image/png;base64,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');
}
#job_list li .t_disable{
    color: #999;
}
#job_list li .t i{
    display: inline-block;
    width:20px;
    height:20px;
    line-height:20px;
    font-size: 12px;
    color:#fff;
    background-color: #d6000f;
    font-style: normal;
    text-align: center;
    vertical-align: top;
    border-radius: 3px;
    margin:10px 5px 0px 0px;
}

#job_list li .yuexin{
    text-align: left;
    //font-weight: bold;
    height: 40px;
    line-height: 40px;
    color: #d6000f;
    font-size:20px;
}
#job_list li .yuexin_disable{
    color: #999;
}
.searchform{
    margin:20px 30px;
}
.searchform .input{
    width:626px;
    height:38px;
    line-height:38px;
    border:1px solid #ccc;
    vertical-align:top;
    outline:none;
    text-indent: 10px;
}
.searchform .button{
    width:160px;
    background-color:#d6000f;
    cursor:pointer;
    color:#fff;
    height:42px;
    line-height:42px;
    border:0px solid #000;
    vertical-align:top;
    outline:none;
}
.searchform a{
    display: inline-block;
    padding:0 20px;
    width:60px;
    height:42px;
    line-height:42px;
    color:#999;
    text-decoration: none;
}
.searchform a:hover{
    color:#333;
}

</style>



// WEBPACK FOOTER //
// src/pages/JobList.vue